import { debugLog } from '../../debug-log';

export const identifyParts = async (extractedData: any) => {
  // Expecting new response shape with Q4400LineItems: [{ PartNumber, Quantity, ... }]
  const URL = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbvan`;

  const lineItems: Array<{ PartNumber?: string; Quantity?: number | string }> =
    extractedData?.Q4400LineItems || [];

  if (!Array.isArray(lineItems) || lineItems.length === 0) return { partsId: [], partsIdentified: [], partsCount: 0 };

  const partNumbers: string[] = lineItems
    .map((i) => (i?.PartNumber ?? '').toString())
    .filter(Boolean);

  try {
    const rawPartsData = await fetch(`${URL}/parts`, {
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Custom-Header': 'mb-cashback-2025-header',
      },
    });
    const parts = await rawPartsData.json();

    const partsFound: any[] = [];
    for (let k = 0; k < parts.length; k++) {
      for (let i = 0; i < partNumbers.length; i++) {
        if (partNumbers[i].includes(parts[k].key)) {
          partsFound.push(parts[k]);
          break;
        }
      }
    }

    const partsCount = lineItems.reduce((acc, item) => {
      const quantity =
        typeof item.Quantity === 'string'
          ? parseFloat(item.Quantity.replace(',', '.'))
          : Number(item.Quantity ?? 0);
      return acc + (isNaN(quantity) ? 0 : quantity);
    }, 0);

    return {
      partsId: partsFound.map((part: any) => part.id),
      partsIdentified: partNumbers,
      partsCount,
    };
  } catch (error) {
    debugLog({ error });
    return { partsId: [], partsIdentified: partNumbers, partsCount: 0 };
  }
};
